import React from 'react'
import _ from 'lodash'
import Width from '../Width'
import Row from '../Row'
import Label from '../Label'
import Input from '../Input/index'
import Yearly from './Yearly'

const hasYearly = (yearly) => !_.isUndefined(yearly)

export default ({ noTopLine, yearly, colorful, bold, ...rest }) => (
  <Width>
    {({ isVerySmall }) => (
      <Row
        noTopLine={noTopLine}
        multiline={hasYearly(yearly) && isVerySmall}
      >
        <Label {...rest} />
        <div style={styles.inputs.container}>
          {hasYearly(yearly) && <Yearly value={yearly} />}
          <Input
            readOnly
            colorful={colorful}
            bold={bold}
            decimalScale={2}
            {...rest}
          />
        </div>
      </Row>
    )}
  </Width>
)

const styles = {
  inputs: {
    container: {
      display: 'flex',
      padding: '5px 0',
    },
  },
}
